<template>
  <main class="container__brand">
    <div class="brand__header">
      <router-link to="/brandCaprimo" class="go__back">
        <img src="@/assets/img/brands/back.svg" alt="icon" />
      </router-link>
      <img class="brand__logo" src="@/assets/img/brands/vanHouten/vanHouten.svg" alt="" />
      <img class="brand__bcg" src="@/assets/img/brands/vanHouten/vanHouten.svg" alt="" />
      <router-link to="/brandMaison" class="go__back__right">
        <img src="@/assets/img/brands/back.svg" alt="icon" />
      </router-link>
    </div>

    <div class="container__clm">
      <Carousell
        :images="[
          require('../../assets/img/brands/vanHouten/p1.png'),
          require('../../assets/img/brands/vanHouten/p2.png'),
        ]"
      />
      <div class="brand__text">
        <div class="text">
          <p>{{ $t('brands.vanHouten.desc') }}</p>
          <p>{{ $t('brands.vanHouten.desc2') }}</p>
          <p>{{ $t('brands.vanHouten.desc3') }}</p>
          <p>{{ $t('brands.vanHouten.desc4') }}</p>
          <br />
          <p class="continets__text">{{ $t('brands.vanHouten.desc5') }}</p>
        </div>

        <div class="brand__continents">
          <img src="@/assets/img/brands/world.svg" alt="" />
        </div>
      </div>
    </div>
    <Button @click="redirect('https://coffeemall.bg/')" class="btn" type="button">{{ $t('buttons.button4') }}</Button>
  </main>
</template>

<script>
import Button from '@/components/Button';
import Carousell from '@/components/Carousell';
export default {
  components: {
    Button,
    Carousell,
  },
  data() {
    return {};
  },
  methods: {
    redirect: function (link, target = '_blank') {
      window.open(link, target);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/base.scss';
@import '@/scss/brands.scss';
.container__brand {
  background: #3b1812 0% 0% no-repeat padding-box;
}
</style>